import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const usePreloadSeed = () => {
  const seed = useSelector(({ preloadSeed }) => preloadSeed);
  return useMemo(() => ({ hasSeed: seed !== null, seed }), [seed]);
};

export default usePreloadSeed;
